module.exports = "/_next/static/images/272f760d065bfd47d629b645b49a7fcf-slide-3-large.png.webp";